import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgAddIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14 37h13v13c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V37h13c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1H37V14c0-.6-.4-1-1-1h-8c-.6 0-1 .4-1 1v13H14c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1z"
      className="add_svg__nc-icon-wrapper"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgAddStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgAddIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const AddIcon: any = SvgAddStyle;
export default AddIcon;
